import styled from 'styled-components';
import { transparentize } from 'polished';
export var Container = styled.div.withConfig({
  displayName: "elements__Container",
  componentId: "sc-64s9f1-0"
})(["position:relative;background-color:", ";overflow-y:auto;max-height:100%;width:100%;"], function (_ref) {
  var palette = _ref.theme.palette;
  return palette.white;
});
export var List = styled.ul.withConfig({
  displayName: "elements__List",
  componentId: "sc-64s9f1-1"
})(["width:100%;list-style:none;overflow-y:auto;transform-origin:50% 0%;"]);
export var Option = styled.li.withConfig({
  displayName: "elements__Option",
  componentId: "sc-64s9f1-2"
})(["display:flex;align-items:center;cursor:pointer;background-color:", ";color:", ";:hover{background:", ";}"], function (_ref2) {
  var isChecked = _ref2.isChecked,
      palette = _ref2.theme.palette;
  return isChecked ? palette.veryLightGrey : 'transparent';
}, function (_ref3) {
  var palette = _ref3.theme.palette;
  return palette.spaceGrey;
}, function (_ref4) {
  var palette = _ref4.theme.palette;
  return palette.veryLightGrey;
});
export var CheckboxOption = styled(Option).withConfig({
  displayName: "elements__CheckboxOption",
  componentId: "sc-64s9f1-3"
})(["padding:0.8rem 1.6rem;"]);
export var RadioOption = styled(Option).withConfig({
  displayName: "elements__RadioOption",
  componentId: "sc-64s9f1-4"
})(["padding:0.8rem 1.6rem;"]);
export var SimpleOption = styled(Option).withConfig({
  displayName: "elements__SimpleOption",
  componentId: "sc-64s9f1-5"
})(["padding:0.8rem 1.6rem;color:", ";background-color:", ";"], function (_ref5) {
  var isChecked = _ref5.isChecked,
      palette = _ref5.theme.palette;
  return isChecked ? palette.primary["default"] : palette.spaceGrey;
}, function (_ref6) {
  var isChecked = _ref6.isChecked,
      palette = _ref6.theme.palette;
  return isChecked ? palette.veryLightGrey : 'transparent';
});
export var NoResultDefaultComponent = styled.div.withConfig({
  displayName: "elements__NoResultDefaultComponent",
  componentId: "sc-64s9f1-6"
})(["padding:0.8rem 1.6rem;"]);
export var SearchInputContainer = styled.div.withConfig({
  displayName: "elements__SearchInputContainer",
  componentId: "sc-64s9f1-7"
})(["position:sticky;z-index:1;top:0;padding:1.6rem;padding-bottom:0;margin-bottom:1rem;background:", ";&:after{position:absolute;content:'';top:100%;left:0;right:0;height:1rem;background:", ";}"], function (_ref7) {
  var palette = _ref7.theme.palette;
  return palette.white;
}, function (_ref8) {
  var palette = _ref8.theme.palette;
  return "linear-gradient(to bottom, ".concat(palette.white, ", ").concat(transparentize(1, palette.white), ")");
});
export var SearchInput = styled.div.withConfig({
  displayName: "elements__SearchInput",
  componentId: "sc-64s9f1-8"
})(["width:100%;border:1px solid ", ";border-radius:0.4rem;background:", ";& > div{background:", ";height:3.2rem;}& input{background:", ";font-size:1.2rem;&::placeholder{font-size:1.2rem;}}"], function (_ref9) {
  var palette = _ref9.theme.palette;
  return palette.lightGrey;
}, function (_ref10) {
  var palette = _ref10.theme.palette;
  return palette.veryLightGrey;
}, function (_ref11) {
  var palette = _ref11.theme.palette;
  return palette.veryLightGrey;
}, function (_ref12) {
  var palette = _ref12.theme.palette;
  return palette.veryLightGrey;
});